import { render } from "./vgooutmonadinfo.vue?vue&type=template&id=c639b854&scoped=true"
import script from "./vgooutmonadinfo.vue?vue&type=script&lang=js"
export * from "./vgooutmonadinfo.vue?vue&type=script&lang=js"

import "./vgooutmonadinfo.vue?vue&type=style&index=0&id=c639b854&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c639b854"]])

export default __exports__